module.exports = __webpack_public_path__ + "img/front cover optimized.0c08339a.jpg";